import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import CbtEntryLink from "../../portal/CbtEntryLink";
import PortalEntryLink from "../../portal/PortalEntryLink";

const SOCIAL_LINKS = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/steeschool",
    icon: <FaFacebookF />
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/steeschools/",
    icon: <FaLinkedinIn />
  },
  {
    label: "X",
    href: "https://x.com/steeschool",
    icon: <FaTwitter />
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/steeschools",
    icon: <FaInstagram />
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/channel/UCtTsMLjlskPQ3Vcfz3UINtA",
    icon: <FaYoutube />
  }
];

function Footer() {
  return (
    <footer className="bg-[#0b1734] px-6 py-16 text-white md:px-12 lg:px-20">
      <div className="mx-auto grid max-w-6xl gap-10 lg:grid-cols-[1.1fr_0.9fr]">
        <div>
          <p className="text-xs uppercase tracking-[0.35em] text-amber-200">
            S-Tee Schools
          </p>
          <h2 className="mt-4 max-w-xl text-4xl md:text-5xl">
            A clearer digital home for learning, leadership, and family trust
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-8 text-slate-200/[0.78] md:text-lg">
            Explore academics, admissions, school culture, and contact support
            from one polished experience designed to guide visitors with more
            confidence.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3" aria-label="Social media">
            {SOCIAL_LINKS.map((socialLink) => (
              <a
                key={socialLink.label}
                href={socialLink.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Visit S-Tee Schools on ${socialLink.label}`}
                title={socialLink.label}
                className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/10 text-white transition hover:-translate-y-0.5 hover:border-amber-200/60 hover:bg-amber-200 hover:text-[#0b1734]"
              >
                {socialLink.icon}
              </a>
            ))}
          </div>
        </div>

        <div className="grid gap-8 sm:grid-cols-2">
          <div className="rounded-[1.75rem] border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-amber-200/90">
              Quick Links
            </p>
            <div className="mt-5 flex flex-col gap-3 text-sm text-slate-100/[0.82]">
              <Link to="/academics" className="transition hover:text-amber-200">
                Academics
              </Link>
              <Link to="/admissions" className="transition hover:text-amber-200">
                Admissions
              </Link>
              <Link to="/gallery" className="transition hover:text-amber-200">
                Gallery
              </Link>
              <Link to="/contact" className="transition hover:text-amber-200">
                Contact
              </Link>
            </div>
          </div>

          <div className="rounded-[1.75rem] border border-white/10 bg-white/5 p-6 backdrop-blur-sm">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-amber-200/90">
              Portal Links
            </p>
            <div className="mt-5 flex flex-col gap-3 text-sm text-slate-100/[0.82]">
              <PortalEntryLink role="educator" className="transition hover:text-amber-200">
                Educator Portal
              </PortalEntryLink>
              <PortalEntryLink role="student" className="transition hover:text-amber-200">
                Student Portal
              </PortalEntryLink>
              <PortalEntryLink role="parent" className="transition hover:text-amber-200">
                Parent Portal
              </PortalEntryLink>
              <CbtEntryLink className="transition hover:text-amber-200">
                CBT Portal
              </CbtEntryLink>
              <PortalEntryLink
                role="applicant"
                className="mt-2 inline-flex w-fit rounded-full bg-[#d4a448] px-5 py-3 text-xs font-bold uppercase tracking-[0.2em] text-slate-900 transition hover:bg-[#e2b65f]"
              >
                Apply Now
              </PortalEntryLink>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
